/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as BlueprintsRouteImport } from './routes/blueprints'
import { Route as McpsRouteImport } from './routes/mcps'
import { Route as ThemeTokensRouteImport } from './routes/theme-tokens'
import { Route as PlatformSecurityApiKeysRouteImport } from './routes/platform/security/api-keys'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const BlueprintsRoute = BlueprintsRouteImport.update({
  id: '/blueprints',
  path: '/blueprints',
  getParentRoute: () => rootRouteImport,
} as any)
const McpsRoute = McpsRouteImport.update({
  id: '/mcps',
  path: '/mcps',
  getParentRoute: () => rootRouteImport,
} as any)
const ThemeTokensRoute = ThemeTokensRouteImport.update({
  id: '/theme-tokens',
  path: '/theme-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformSecurityApiKeysRoute = PlatformSecurityApiKeysRouteImport.update({
  id: '/platform/security/api-keys',
  path: '/platform/security/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/theme-tokens'
    | '/platform/security/api-keys'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/theme-tokens'
    | '/platform/security/api-keys'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/theme-tokens'
    | '/platform/security/api-keys'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  ApiKeysRoute: typeof ApiKeysRoute
  BlueprintsRoute: typeof BlueprintsRoute
  McpsRoute: typeof McpsRoute
  ThemeTokensRoute: typeof ThemeTokensRoute
  PlatformSecurityApiKeysRoute: typeof PlatformSecurityApiKeysRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blueprints': {
      id: '/blueprints'
      path: '/blueprints'
      fullPath: '/blueprints'
      preLoaderRoute: typeof BlueprintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcps': {
      id: '/mcps'
      path: '/mcps'
      fullPath: '/mcps'
      preLoaderRoute: typeof McpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/theme-tokens': {
      id: '/theme-tokens'
      path: '/theme-tokens'
      fullPath: '/theme-tokens'
      preLoaderRoute: typeof ThemeTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/security/api-keys': {
      id: '/platform/security/api-keys'
      path: '/platform/security/api-keys'
      fullPath: '/platform/security/api-keys'
      preLoaderRoute: typeof PlatformSecurityApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  ApiKeysRoute: ApiKeysRoute,
  BlueprintsRoute: BlueprintsRoute,
  McpsRoute: McpsRoute,
  ThemeTokensRoute: ThemeTokensRoute,
  PlatformSecurityApiKeysRoute: PlatformSecurityApiKeysRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
